import styled from "styled-components";
import { Wrapper } from "../../InlineImageCropper/InlineImageCropper.styled";

export const SPOTIFY_IMAGE_SIZE_SPEC = {
  width: 380,
  pictureWidth: 350,
  minHeight: 350,
  maxHeight: 350
};

export const companyNameStyle = {
  textAlign: "left",
  fontSize: "11px",
  fontWeight: 600,
  color: "#fff"
};
export const titleStyle = {
  textAlign: "left",
  fontSize: "11px",
  fontWeight: 500,
  color: "#fff"
};

export const PostEditorSpotifyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${SPOTIFY_IMAGE_SIZE_SPEC.width}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: ${({ background }) => background || "#19191b"};
  border-radius: 10px;
  padding: 15px;
  position: relative;
`;
export const MobileHead = styled.div`
  color: white;
  font-size: 14px;
  text-align: left;
  padding-left: 10px;
`;
export const Header = styled.div`
  margin: 30px 0 20px;
  width: 100%;
  color: white;
  font-size: 14px;
  text-align: center;
`;
export const Ad = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
`;
export const ChannelDataHeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ApplyButton = styled.a`
  display: inline-block;
  background-color: #ffffff;
  color: #0c0c0c;
  border-radius: 50px;
  border: none;
  padding: 10px 22px;
  font-size: 16px;
  font-weight: 600;
  height: 36px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  &:hover {
    color: #0c0c0c;
    background-color: #efefef;
  }
`;

export const PhotoWrapper = styled.div`
  position: relative;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PageLogoWrapper = styled.div`
  position: absolute;
  z-index: 3;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);

  ${Wrapper} {
    margin-bottom: 0;
  }
`;
